import PropTypes from "prop-types";

const ResponseNote = ({ text, responseId, changeNote }) => {
  const handleOnChange = (event) => {
    changeNote({ responseId: responseId, note: event.target.value });
  };

  const idName = `response-${responseId}-note`;
  const textValue = text || "";

  return (
    <div className="response-note-area">
      <textarea
        id={idName}
        className="response-note"
        value={textValue}
        placeholder="Remind yourself of something..."
        onChange={handleOnChange}
      />
    </div>
  );
};

ResponseNote.propTypes = {
  text: PropTypes.string,
  responseId: PropTypes.number,
  changeNote: PropTypes.func,
};

export default ResponseNote;
